import KEY_CODES from '../../../../../../editJournal/constants/keyCodes';

export default (event) => {
  const { ctrlKey, metaKey, shiftKey, which } = event;

  if (
    ((ctrlKey || metaKey) &&
      ((which === KEY_CODES.Z && shiftKey) || which === KEY_CODES.Y)) ||
    ((ctrlKey || metaKey) && which === KEY_CODES.Z)
  ) {
    event.preventDefault();
    return true;
  }

  return false;
};
